<template>
    <div v-loading="isLoadingTrucks || isLoadingSchedules || isLoadingPlaces || isLoadingSetting || isLoadingContractors">
        <!-- Add New Schedule Button -->
        <el-row>
            <el-col :span="24">
                <el-button
                        type="primary"
                        icon="el-icon-plus"
                        @click="handleOpenScheduleModal(null)"
                        v-if="settingHasAccess"
                >
                    Add
                </el-button>
                <el-dialog
                        :title="modalHeader"
                        :visible.sync="showScheduleModal"
                        top="10vh"
                        @closed="handleClosedScheduleModal"
                >
                    <el-form
                            v-if="showScheduleForm"
                            ref="form"
                            :model="form"
                            label-width="120px"
                            :rules="rules"
                    >
                        <el-form-item label="ID" prop="id" v-show="false">
                            <el-input v-model="form.id"></el-input>
                        </el-form-item>
                        <el-form-item label="Name" prop="name">
                            <el-input
                                    v-model="form.name"
                                    placeholder="Please enter the name"
                                    class="el-form-item-inside"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Contractor" prop="contractorId">
                            <el-select
                                    class="el-form-item-inside"
                                    v-model="form.contractorId"
                                    placeholder="Please select a contractor"
                                    filterable
                                    clearable
                            >
                                <el-option
                                        v-for="contractor in contractors"
                                        :label="contractor.name"
                                        :key="contractor.id"
                                        :value="contractor.id"
                                >
                                    <span>{{contractor.name}}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Origin" prop="placeOriginId">
                            <el-select
                                    class="el-form-item-inside"
                                    v-model="form.placeOriginId"
                                    placeholder="Please select origin place"
                                    filterable
                            >
                                <el-option
                                        v-for="place in places"
                                        :label="place.name"
                                        :key="place.id"
                                        :value="place.id"
                                >
                                    <span>{{place.name}}</span>
                                    <span style="float:right;color:#ccc">{{place.address_readable}}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="STD" prop="std">
                            <el-time-picker
                                    class="el-form-item-inside"
                                    v-model="form.std"
                                    format="HH:mm"
                                    placeholder="Please select STD"
                                    value-format="HH:mm"
                                    arrow-control
                            >
                            </el-time-picker>
                        </el-form-item>
                        <el-form-item label="Destination" prop="placeDestinationId">
                            <el-select
                                    class="el-form-item-inside"
                                    v-model="form.placeDestinationId"
                                    placeholder="Please select destination place"
                                    filterable
                            >
                                <el-option
                                        v-for="place in places"
                                        :label="place.name"
                                        :key="place.id"
                                        :value="place.id"
                                >
                                    <span>{{place.name}}</span>
                                    <span style="float:right;color:#ccc">{{place.address_readable}}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="STA" prop="sta">
                            <el-time-picker
                                    class="el-form-item-inside"
                                    v-model="form.sta"
                                    format="HH:mm"
                                    placeholder="Please select STA"
                                    value-format="HH:mm"
                                    arrow-control
                            >
                            </el-time-picker>
                        </el-form-item>
                        <el-form-item label="STA add day(s)" prop="staAddDays">
                            <el-select
                                    v-model="form.staAddDays"
                                    class="el-form-item-inside"
                            >
                                <el-option v-for="day in daysList" :value="day.value" :key="day.value" :label="day.label"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Days" prop="daysOfWeek">
                            <el-checkbox-group
                                    v-model="form.daysOfWeek"
                                    class="el-form-item-inside"
                            >
                                <el-checkbox v-for="dayOfWeek in daysOfWeek" :label="dayOfWeek.value" :key="dayOfWeek.value">
                                    <span>{{dayOfWeek.name}}</span>
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="Trucks" prop="truckIds">
                            <el-select
                                    class="el-form-item-inside"
                                    v-model="form.truckIds"
                                    multiple
                                    filterable
                            >
                                <el-option
                                        v-for="truck in trucks"
                                        :value="truck.id"
                                        :key="truck.id"
                                        :label="truck.detailedPlate"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <!--Form Buttons-->
                        <el-form-item>
                            <el-button v-if="this.form.id" type="primary" @click="handleSubmit('form')" :loading="isUpdatingSchedule">Save</el-button>
                            <el-button v-else type="primary" @click="handleSubmit('form')" :loading="isAddingSchedule">Create</el-button>
                            <el-button @click="handleReset('form')">Reset</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </el-col>
        </el-row>
        <br/>
        <!-- Schedules Table -->
        <el-row>
            <el-col :span="24">
                <el-table
                        v-if="! isLoadingSetting"
                        style="width: 100%"
                        :data="schedules"
                        border
                >
                    <el-table-column
                            prop="name"
                            label="Name"
                            min-width="9%"
                    ></el-table-column>
                    <el-table-column
                            prop="contractorName"
                            label="Contractor"
                            :show-overflow-tooltip="true"
                            :filters="contractorFilters"
                            :filter-method="filterEqual"
                            min-width="12%"
                    ></el-table-column>
                    <el-table-column
                            prop="placeOriginName"
                            label="Origin"
                            :show-overflow-tooltip="true"
                            :filters="originFilters"
                            :filter-method="filterEqual"
                            min-width="13%"
                    ></el-table-column>
                    <el-table-column
                            prop="std"
                            label="STD"
                            min-width="8%"
                    ></el-table-column>
                    <el-table-column
                            prop="placeDestinationName"
                            label="Destination"
                            :show-overflow-tooltip="true"
                            :filters="destinationFilters"
                            :filter-method="filterEqual"
                            min-width="12%"
                    ></el-table-column>
                    <el-table-column
                            prop="staAbb"
                            label="STA"
                            min-width="8%"
                    ></el-table-column>
                    <el-table-column
                            prop="trucksAbb"
                            label="Trucks"
                            :show-overflow-tooltip="true"
                            min-width="10%"
                    ></el-table-column>
                    <el-table-column
                            prop="daysOfWeekAbb"
                            label="Days of week"
                            :show-overflow-tooltip="true"
                            min-width="13%"
                    ></el-table-column>
                    <el-table-column label="Actions" align="center" min-width="15%" v-if="settingHasAccess">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="handleOpenScheduleModal(scope.row)">Edit</el-button>
                            <el-button size="mini" type="text" @click="handleDeleteSchedule(scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <br/>
                <el-alert
                        v-if="! settingHasAccess"
                        :title="`Found something wrong? Please contact ${businessOwner} to update the information.`"
                        type="info"
                        show-icon>
                </el-alert>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'JourneySchedulesCarrier',
        data () {
            let validatePlaceOriginId = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please select the origin'));
                } else if (this.form.placeDestinationId !== '' && value === this.form.placeDestinationId) {
                    callback(new Error('Please select a different place from destination'));
                } else {
                    callback();
                }
            };
            let validatePlaceDestinationId = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please select the destination'));
                } else if (this.form.placeOriginId !== '' && value === this.form.placeOriginId) {
                    callback(new Error('Please select a different place from origin'));
                } else {
                    callback();
                }
            };
            const emptyForm = {
                id: '',
                name: '',
                placeOriginId: '',
                placeDestinationId: '',
                contractorId: '',
                std: '',
                sta: '',
                staAddDays: 0,
                truckIds: [],
                daysOfWeek: [1, 2, 3, 4, 5],
            };
            return {
                daysOfWeek: [
                    {name: "Sunday", value: 0},
                    {name: "Monday", value: 1},
                    {name: "Tuesday", value: 2},
                    {name: "Wednesday", value: 3},
                    {name: "Thursday", value: 4},
                    {name: "Friday", value: 5},
                    {name: "Saturday", value: 6},
                ],
                daysList: [
                    {
                        value: 0,
                        label: 'Same day'
                    },
                    {
                        value: 1,
                        label: '+ 1 Day'
                    },
                    {
                        value: 2,
                        label: '+ 2 Days'
                    },
                    {
                        value: 3,
                        label: '+ 3 Days'
                    },
                ],
                showScheduleModal: false,
                showScheduleForm: false,
                //form
                emptyForm,
                form: emptyForm,
                rules: {
                    placeOriginId: [
                        { required: true, type: 'string', message: 'Please select the origin', trigger: 'change' },
                        { validator: validatePlaceOriginId, trigger: 'change' }
                    ],
                    std: [
                        { required: true, type: 'string', message: 'Please select STD (Schedule Time of Departure)', trigger: 'blur' }
                    ],
                    placeDestinationId: [
                        { required: true, type: 'string', message: 'Please select the destination', trigger: 'change' },
                        { validator: validatePlaceDestinationId, trigger: 'change' }
                    ],
                    sta: [
                        { required: true, type: 'string', message: 'Please select STA (Schedule Time of Arrival)', trigger: 'blur' }
                    ],
                    staAddDays: [
                        { required: true, type: 'number', message: 'Please select STA add day(s)', trigger: 'change' }
                    ],
                    daysOfWeek: [
                        { required: true, type: 'array', min: 1, message: 'Choose at least one day of week', trigger: 'change' }
                    ],
                    truckIds: [
                        { required: true, type: 'array', min: 1, message: 'Choose at least one truck', trigger: 'change' }
                    ],
                    contractorId: [
                        { type: 'string', trigger: 'change'}
                    ],
                },
            }
        },
        computed: {
            businessOwner() {
                return typeof window.Freighthub.business !== 'undefined' ? window.Freighthub.business.ownerName : 'Business Owner';
            },
            settingHasAccess () {
                return this.$store.getters.getIfSettingHasAccess;
            },
            isLoadingSetting () {
                return this.$store.getters.getTruckRunningSettingLoadStatus === 1;
            },
            schedules: function () {
                return this.$store.getters.getTruckRunningSchedules;
            },
            isLoadingSchedules: function () {
                return this.$store.getters.getTruckRunningSchedulesLoadStatus === 1;
            },
            isUpdatingSchedule: function () {
                return this.$store.getters.getTruckRunningScheduleUpdateStatus === 1;
            },
            isAddingSchedule: function () {
                return this.$store.getters.getTruckRunningScheduleAddStatus === 1;
            },
            places: function () {
                return this.$store.getters.getPlaces;
            },
            isLoadingPlaces: function () {
                return this.$store.getters.getPlacesLoadStatus === 1;
            },
            contractors: function () {
                return this.$store.getters.getContractors;
            },
            isLoadingContractors: function () {
                return this.$store.getters.getContractorsLoadStatus === 1;
            },
            trucks: function () {
                return this.$store.getters.getTrucks;
            },
            isLoadingTrucks: function () {
                return this.$store.getters.getTrucksLoadStatus === 1;
            },
            modalHeader: function () {
                if (this.form.id) {
                    return `Edit the Schedule from ${this.form.placeOriginName} to ${this.form.placeDestinationName}`;
                } else {
                    return 'New Schedule';
                }
            },
            originFilters () {
                const schedules = [...this.schedules];
                let originNames = schedules.map(schedule => {
                    return schedule.placeOriginName;
                });
                return this.uniqueArray(originNames).sort().map(name => { return {'text': name, 'value': name} });
            },
            destinationFilters () {
                const schedules = [...this.schedules];
                let destinationNames = schedules.map(schedule => {
                    return schedule.placeDestinationName;
                });
                return this.uniqueArray(destinationNames).sort().map(name => { return {'text': name, 'value': name} });
            },
            contractorFilters () {
                const schedules = [...this.schedules];
                let contractorNames = schedules.map(schedule => {
                    return schedule.contractorName;
                });
                return this.uniqueArray(contractorNames).sort().map(name => { return {'text': name, 'value': name} });
            },
        },
        // when component uses other components
        components: {},
        // methods
        watch: {},
        methods: {
            filterEqual (value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            uniqueArray (arrArg) {
                return arrArg.filter((elem, pos, arr) => {
                    return arr.indexOf(elem) === pos;
                });
            },
            //load API data
            loadPlaces () {
                this.$store.dispatch('loadPlaces')
                    .catch(() => {
                        this.$message.error('Sorry, failed to load your places.');
                    });
            },
            loadTrucks () {
                this.$store.dispatch('loadTrucks', { type: 'minute' })
                    .catch((error) => {
                        this.$message.error('Sorry, failed to load your trucks.');
                    });
            },
            loadSchedules() {
                this.$store.dispatch('loadTruckRunningSchedules')
                    .catch((error) => {
                        this.$message.error('Sorry, failed to load your schedules.');
                    });
            },
            deleteSchedule(scheduleId) {
                return this.$store.dispatch('deleteTruckRunningSchedule', scheduleId);
            },
            //modal
            handleOpenScheduleModal (schedule) {
                if (schedule) {
                    this.form = {...schedule};
                } else {
                    this.form = {...this.emptyForm};
                }
                this.openScheduleModal();
            },
            handleClosedScheduleModal () {
                this.showScheduleForm = false;
            },
            openScheduleModal () {
                this.showScheduleModal = true;
                this.showScheduleForm = true;
            },
            closeScheduleModal () {
                this.showScheduleModal = false;
            },
            handleDeleteSchedule(schedule) {
                this.$confirm('Sure to delete？', 'Confirm', {
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = 'Deleting...';
                            this.deleteSchedule(schedule.id)
                                .then(res => {
                                    console.log(res);
                                    this.$message.success('Deleted the schedule successfully.')
                                }).catch((error) => {
                                    console.log(error);
                                    this.$message.error('Failed to schedule the schedule.');
                                }).then(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                                });
                        } else {
                            done();
                        }
                    }
                });
            },
            //form
            handleReset (name) {
                this.$refs[name].resetFields();
            },
            handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        //create a new schedule
                        if (this.form.id === '') {
                            this.$store.dispatch('addTruckRunningSchedule', this.form)
                                .then(() => {
                                    this.closeScheduleModal();
                                    this.$Message.success('Created a new schedule successfully.');
                                }).catch(e => {
                                    console.log(e);
                                    this.$message.error('Sorry, failed to create a new schedule.');
                            });
                        } else {
                            //edit a schedule
                            this.$store.dispatch('updateTruckRunningSchedule', this.form)
                                .then(() => {
                                    this.closeScheduleModal();
                                    this.$Message.success('Updated this schedule successfully.');
                                }).catch(e => {
                                    console.log(e);
                                    this.$message.error('Sorry, failed to update this schedule.');
                            });
                        }
                    } else {
                        this.$message.error('Sorry, failed to validate the form.');
                    }
                })
            },
        },
        mounted() {
            this.loadSchedules();
            this.loadTrucks();
            this.loadPlaces();
        },
    };
</script>

<style scoped>
    .el-form-item-inside {
        width: 80%;
    }
</style>